import {
  IMAGE_ACTION,
  IMAGE_ASPECT_RATIOS,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": IMAGE_MODEL_ID.NANO_BANANA_TEXT_TO_IMAGE_NB2_LITE,
  "provider": PROVIDER.NANO_BANANA,
  "action": IMAGE_ACTION.TEXT_TO_IMAGE,
  "mode": IMAGE_MODE.NB2_LITE,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
      },
      "aspect_ratio": {
        "type": "string",
        "enum": IMAGE_ASPECT_RATIOS,
      },
      "num_images": {
        "type": "integer",
        "minimum": 1,
        "maximum": 4,
      },
    },
    "required": ["prompt"],
  },
  "ui_schema": {},
}
